module.exports = __webpack_public_path__ + "static/media/glass.5bea0d11.png";